module.exports = __webpack_public_path__ + "img/Icon_btn_map.a6670f29.svg";